import React from 'react';

import { BringgInput } from '@bringg/react-components';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import styles from './search-input.module.scss';

interface Props {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	autoFocus?: boolean;
	'data-test-id'?: string;
}

export const SearchInput = ({ value, onChange, placeholder, autoFocus, 'data-test-id': dataTestId }: Props) => (
	<div className={styles.searchInputWrapper}>
		<BringgInput
			role="search"
			allowClear
			autoFocus={autoFocus}
			placeholder={placeholder}
			value={value}
			onChange={e => onChange(e.target.value)}
			prefix={<BringgIcon className={styles.searchIcon} iconName={BringgFontIcons.Search} />}
			className={styles.searchInput}
			data-test-id={dataTestId}
		/>
		<div className={styles.divider} />
	</div>
);
